<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4">Exam Alerts</nz-page-header-title>
    <nz-page-header-extra class="mr4">
      <button
        nz-button
        nzType="primary"
        [routerLink]="['add']"
        [queryParams]="{ index: index }"
        routerLinkActive="router-link-active"
        class="submitoraddbutton"
      >
        Add Exam Alert
      </button>
    </nz-page-header-extra>
  </nz-page-header>
</div>

<!-- ─── Filters ─── -->
<div nz-row nzJustify="end" [nzGutter]="{ xs: 8, sm: 16, md: 24 }" class="mt4">
  <!-- Category Filter -->
  <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
    <nz-form-label>Category</nz-form-label>
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Filter by Category"
          [(ngModel)]="selectedCategory"
          (ngModelChange)="onCategoryChange($event)"
          (nzOnSearch)="onCategorySearch($event)"
          (nzScrollToBottom)="loadMoreCategories()"
        >
          <nz-option
            *ngFor="let cat of listOfCategories"
            [nzLabel]="cat.categoryName"
            [nzValue]="cat._id"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <!-- Job Type Filter -->
  <div nz-col nzLg="5" nzMd="5" nzSm="24" nzXs="24">
    <nz-form-label>Exam Type</nz-form-label>
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <nz-select
          nzAllowClear
          nzPlaceHolder="Filter by Type"
          [(ngModel)]="selectedJobType"
          (ngModelChange)="onJobTypeChange($event)"
        >
          <nz-option
            *ngFor="let type of jobTypes"
            [nzLabel]="type"
            [nzValue]="type"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <!-- Date Range -->
  <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
    <nz-form-label>Apply End Date Range</nz-form-label>
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <nz-range-picker
          class="width-100"
          [(ngModel)]="dateRange"
          (ngModelChange)="onChangeDateRange($event)"
        ></nz-range-picker>
      </nz-form-control>
    </nz-form-item>
  </div>

  <!-- Search -->
  <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24" class="mb5 ml3">
    <nz-form-label>Search</nz-form-label>
    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input
        type="text"
        nz-input
        placeholder="Search by exam Alert title"
        ngModel
        (ngModelChange)="searchJobAlerts($event)"
      />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </div>
</div>

<!-- ─── Tabs ─── -->
<nz-tabset
  (nzSelectedIndexChange)="changeIndex($event)"
  [nzSelectedIndex]="index"
>
  <!-- ══════════ TAB 1: Approved ══════════ -->
  <nz-tab nzTitle="Approved Exam Alerts">
    <nz-table
      #approvedTbl
      [nzData]="allApprovedJobAlerts"
      [nzLoading]="loading"
      [nzTotal]="totalApprovedDataCount"
      [(nzPageSize)]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzFrontPagination]="false"
      (nzQueryParams)="onQueryParamsChange($event)"
      nzShowSizeChanger
      [nzScroll]="{ x: '1100px' }"
    >
      <thead>
        <tr>
          <th nzColumnKey="title" [nzSortFn]="true" nzWidth="220px">Title</th>
          <th nzWidth="150px">Category</th>
          <th nzWidth="120px">Exam Type</th>
          <th nzWidth="100px">State</th>
          <th nzWidth="100px">Vacancy</th>
          <th nzWidth="140px">Apply End Date</th>
          <th nzWidth="140px">Created Date</th>
          <th nzWidth="140px">Published Status</th>
          <th nzWidth="90px">Status</th>
          <th class="text-right" nzWidth="120px">Action</th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="onDropApproved($event)">
        <tr *ngFor="let data of approvedTbl.data" cdkDrag style="cursor: grab">
          <td>
            <i
              nz-icon
              nzType="drag"
              nzTheme="outline"
              style="margin-right: 8px"
            ></i>
            <span class="ellipsis">{{ data.title }}</span>
          </td>
          <td>{{ data.jobCategory?.categoryName || "—" }}</td>
          <td>
            <nz-tag [nzColor]="getJobTypeColor(data.jobType)">{{
              data.jobType
            }}</nz-tag>
          </td>
          <td>{{ data.state }}</td>
          <td>{{ data.totalVacancy | number }}</td>
          <td>{{ data.applyEndDate | date: "dd MMM yyyy" }}</td>
          <td>
            {{ data.createdDate || data.createdAt | date: "dd MMM yyyy" }}
          </td>
          <td>
            <ng-container
              *ngIf="userRole === 'admin'; else publishedStatusText"
            >
              <nz-select
                nzPlaceHolder="Published Status"
                [(ngModel)]="data.publishedStatus"
                (ngModelChange)="updatePublishedStatus(data._id, $event)"
                nzSize="small"
                class="width-100"
              >
                <nz-option
                  *ngFor="let status of publishedStatusOptions"
                  [nzLabel]="status | uppercase"
                  [nzValue]="status"
                ></nz-option>
              </nz-select>
            </ng-container>
            <ng-template #publishedStatusText>
              {{ data.publishedStatus || "—" }}
            </ng-template>
          </td>
          <td>
            <span
              class="{{ data.status ? 'active' : 'inactive' }} status"
            ></span>
          </td>
          <td class="action-buttons">
            <a
              nz-button
              nzTooltipTitle="Edit"
              nzTooltipPlacement="topCenter"
              nz-tooltip
              [routerLink]="['update', data._id]"
              [queryParams]="{ index: index }"
              routerLinkActive="router-link-active"
            >
              <i nz-icon nzType="form" nzTheme="outline"></i>
            </a>
            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure {{
                data.status ? 'deactivate' : 'activate'
              }} this exam alert?"
              (nzOnConfirm)="updateStatus(data._id, data.status)"
              nzTooltipTitle="{{ data.status ? 'Deactivate' : 'Activate' }}"
              nzTooltipPlacement="topRight"
              nz-tooltip
            >
              <i
                nz-icon
                [nzType]="data.status ? 'stop' : 'check'"
                nzTheme="outline"
              ></i>
            </a>
            <a
              *ngIf="userRole === 'admin'"
              class="action-button delete"
              nz-button
              nzDanger
              nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to delete this exam alert?"
              (nzOnConfirm)="deleteJobAlert(data._id)"
              nzTooltipTitle="Delete"
              nzTooltipPlacement="topRight"
              nz-tooltip
            >
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>

  <!-- ══════════ TAB 2: Un-approved ══════════ -->
  <nz-tab nzTitle="Un-approved Exam Alerts">
    <nz-table
      #unapprovedTbl
      [nzData]="allJobAlerts"
      [nzLoading]="loading"
      [nzTotal]="totalDataCount"
      [(nzPageSize)]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzFrontPagination]="false"
      (nzQueryParams)="onQueryParamsChange($event)"
      nzShowSizeChanger
      [nzScroll]="{ x: '1200px' }"
    >
      <thead>
        <tr>
          <th nzColumnKey="title" [nzSortFn]="true" nzWidth="200px">Title</th>
          <th nzWidth="140px">Category</th>
          <th nzWidth="120px">Job Type</th>
          <th nzWidth="100px">Vacancy</th>
          <th nzWidth="130px">Apply End Date</th>
          <th nzWidth="140px">Created Date</th>
          <th nzWidth="130px">Created By</th>
          <th nzWidth="150px">Rejected Reason</th>
          <th nzWidth="120px">Published Status</th>
          <th nzWidth="110px">Approve Status</th>
          <th class="text-right" nzWidth="160px">Action</th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="onDropUnapproved($event)">
        <tr
          *ngFor="let data of unapprovedTbl.data"
          cdkDrag
          style="cursor: grab"
        >
          <td>
            <i
              nz-icon
              nzType="drag"
              nzTheme="outline"
              style="margin-right: 8px"
            ></i>
            <span class="ellipsis">{{ data.title }}</span>
          </td>
          <td>{{ data.jobCategory?.categoryName || "—" }}</td>
          <td>
            <nz-tag [nzColor]="getJobTypeColor(data.jobType)">{{
              data.jobType
            }}</nz-tag>
          </td>
          <td>{{ data.totalVacancy | number }}</td>
          <td>{{ data.applyEndDate | date: "dd MMM yyyy" }}</td>
          <td>
            {{ data.createdDate || data.createdAt | date: "dd MMM yyyy" }}
          </td>
          <td>
            <span *ngIf="data.createdBy?.role === 'subAdmin'">{{
              data.createdBy?.name
            }}</span>
          </td>
          <td>
            <span *ngIf="data.rejectionReason" class="ellipsis">{{
              data.rejectionReason
            }}</span>
          </td>
          <td>
            <ng-container
              *ngIf="userRole === 'admin'; else publishedStatusTextUnapproved"
            >
              <nz-select
                nzPlaceHolder="Published Status"
                [(ngModel)]="data.publishedStatus"
                (ngModelChange)="updatePublishedStatus(data._id, $event)"
                nzSize="small"
                class="width-100"
              >
                <nz-option
                  *ngFor="let status of publishedStatusOptions"
                  [nzLabel]="status | uppercase"
                  [nzValue]="status"
                ></nz-option>
              </nz-select>
            </ng-container>
            <ng-template #publishedStatusTextUnapproved>
              {{ data.publishedStatus || "—" }}
            </ng-template>
          </td>
          <td>
            <nz-tag
              [nzColor]="
                data.approveStatus === 'approved'
                  ? 'green'
                  : data.approveStatus === 'pending'
                    ? 'lime'
                    : 'volcano'
              "
            >
              {{ data.approveStatus }}
            </nz-tag>
          </td>
          <td class="action-buttons">
            <!-- Edit -->
            <a
              nz-button
              nzTooltipTitle="Edit"
              nzTooltipPlacement="topCenter"
              nz-tooltip
              [routerLink]="['update', data._id]"
              [queryParams]="{ index: index }"
              routerLinkActive="router-link-active"
            >
              <i nz-icon nzType="form" nzTheme="outline"></i>
            </a>
            <!-- Active/Inactive -->
            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure {{
                data.status ? 'deactivate' : 'activate'
              }} this job alert?"
              (nzOnConfirm)="updateStatus(data._id, data.status)"
              nzTooltipTitle="{{ data.status ? 'Deactivate' : 'Activate' }}"
              nzTooltipPlacement="topRight"
              nz-tooltip
            >
              <i
                nz-icon
                [nzType]="data.status ? 'stop' : 'check'"
                nzTheme="outline"
              ></i>
            </a>
            <!-- Approve -->
            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button top-margin"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to approve this job alert?"
              (nzOnConfirm)="updateApproveStatus(data._id, 'approved')"
              nzTooltipTitle="Approve"
              nzTooltipPlacement="topRight"
              nz-tooltip
            >
              <i nz-icon nzType="file-done" nzTheme="outline"></i>
            </a>
            <!-- Reject -->
            <a
              *ngIf="
                userRole !== 'subAdmin' && data.approveStatus !== 'rejected'
              "
              class="action-button top-margin delete"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to reject this job alert?"
              (nzOnConfirm)="openRejectionReason(data._id)"
              nzTooltipTitle="Reject"
              nzTooltipPlacement="topRight"
              nz-tooltip
            >
              <i nz-icon nzType="close-circle" nzTheme="fill"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>
</nz-tabset>
